import React from "react";
import { DateField } from "react-admin";
import { useProfileLocale } from "./locale";

const CustomDateField = (props) => {
  const locale = useProfileLocale();
  //remove the follwing to use Boxify custom locale setting in params
  // const locale = useMemo(
  //   () => resolveBrowserLocale(undefined, { fullLocale: true }),
  //   []
  // );
  return <DateField locales={locale} {...props} />;
};

export default CustomDateField;
